import { VendorRefundInfoResponse } from './VendorRefundInfo';

/**
 * Contains vendor refund details for this transaction
 */

export interface VendorsRefundInfoResponse {
    vendorRefundInfo: VendorRefundInfoResponse[];
}
